import { render, staticRenderFns } from "./ViewOnlyStudentLibraryPage.vue?vue&type=template&id=3e0200ac&scoped=true"
import script from "./ViewOnlyStudentLibraryPage.vue?vue&type=script&lang=js"
export * from "./ViewOnlyStudentLibraryPage.vue?vue&type=script&lang=js"
import style0 from "./ViewOnlyStudentLibraryPage.vue?vue&type=style&index=0&id=3e0200ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0200ac",
  null
  
)

export default component.exports